"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = validateIban;
function validateIban(value, isYKBIban) {
  if (!value || value.replace(/\s+/g, '').length !== 26) {
    //Validating digit count of IBAN
    return false;
  }
  var ibanNo = '';
  var regEx = new RegExp(/^[a-z0-9]+$/i);
  for (var i = 0; i < value.length; i++) {
    if (regEx.test(value.charAt(i))) {
      ibanNo += value.charAt(i);
    }
  }
  if (ibanNo.length < 4) {
    return false;
  }

  // converts letters to digits

  var tmpIban = '';
  tmpIban = prepareIbanFormat(ibanNo);
  ibanNo = tmpIban;
  if (mod97(ibanNo) !== 1) {
    return false;
  }

  // validate isYKB Iban
  if (isYKBIban) {
    var bankCode = '00067';
    if (bankCode === value.replace(/\s+/g, '').substring(4, 9)) {
      return true;
    }
  } else {
    return true;
  }
  return false;
}
function mod97(iban) {
  var remainder = iban,
    block;
  while (remainder.length > 2) {
    block = remainder.slice(0, 9);
    remainder = parseInt(block, 10) % 97 + remainder.slice(block.length);
  }
  return parseInt(remainder, 10) % 97;
}

/**
     * Prepare an IBAN for mod 97 computation by moving the first 4 chars to the end and transforming the letters to
     * numbers (A = 10, B = 11, ..., Z = 35), as specified in ISO13616.
     
     * @param {string} iban the IBAN
     * @returns {string} the prepared IBAN
     */
function prepareIbanFormat(iban) {
  var A = 'A'.charCodeAt(0),
    Z = 'Z'.charCodeAt(0);
  iban = iban.toUpperCase();
  iban = iban.substr(4) + iban.substr(0, 4);
  return iban.split('').map(function (n) {
    var code = n.charCodeAt(0);
    if (code >= A && code <= Z) {
      // A = 10, B = 11, ... Z = 35
      return code - A + 10;
    } else {
      return n;
    }
  }).join('');
}